import React from "react";
import { Homepage } from "../views/home/Home";
import { Blog } from "../views/blog/Blog";
import { CareerDetail } from "../views/careers/CareerDetail";
import { TermsAndCondition } from "../views/terms/TermsAndCondition";
import { RefundAndReturn } from "../views/terms/RefundAndReturn";
import { Enquiry } from "../views/terms/Enquiry";
import { MarketArea } from "../views/terms/MarketArea";
import { CustmerReview } from "../views/terms/CustomerReview";
import { Aboutus } from "../views/aboutus/AboutUs";
import { BlogDetail } from "../views/blog/BlogDetail";
import { Career } from "../views/careers/Career";
import { Contectus } from "../views/contactus/ContactUs";
import { Faq } from "../views/faq/Faq";
import { PrivacyPolicy } from "../views/privacypolicy/PrivancyPolicy";
import TrackOrder from "../views/trackorder/TrackOrder";
import DynamicRouteHandler from "./DynamicRouteHandler";
import Franchise from "../views/franchise/Franchise";

export const RouteData = [
  {
    path: `/`,
    element: <Homepage />,
  },
  {
    path: "/:slug/",
    element: <DynamicRouteHandler />,
  },
  {
    path: "/:cityName/:slug",
    element: <DynamicRouteHandler />,
  },
  {
    path: "/about/",
    element: <Aboutus />,
  },
  {
    path: "/clothing-franchise",
    element: <Franchise />,
  },
  {
    path: "/career/",
    element: <Career />,
  },
  {
    path: "/contact-us/",
    element: <Contectus />,
  },
  {
    path: "/privacy-policy-2/",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-condition/",
    element: <TermsAndCondition />,
  },
  {
    path: "/return-policy/",
    element: <RefundAndReturn />,
  },
  {
    path: "/enquiry-ktc/",
    element: <Enquiry />,
  },
  {
    path: "/enquiry-ktc/:name",
    element: <Enquiry />,
  },
  {
    path: "/market-area/",
    element: <MarketArea />,
  },
  {
    path: "/customer-review/",
    element: <CustmerReview />,
  },
  {
    path: "/track-your-delivery/",
    element: <TrackOrder />,
  },
  {
    path: "/career/:id",
    element: <CareerDetail />,
  },
  {
    path: "/faq/",
    element: <Faq />,
  },
  {
    path: "/blog/",
    element: <Blog />,
  },
  {
    path: "/blog/:categoryname",
    element: <Blog />,
  },
];
